module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('balancebox'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("Проекты для инвестиций")])]), _vm._v(" "), _vm._l((_vm.Projects), function(project, index) {
    return _c('v-flex', {
      key: project.id,
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('v-card', {
      staticClass: "elevation-1 cardProject"
    }, [_c('v-card-title', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Проект',
          params: {
            id: project.id
          }
        },
        "text-right": ""
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Объем закупки (т.):")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.quantity) + " из " + _vm._s(project.maxQuantity))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Сумма закупки:")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.sum) + " из " + _vm._s(project.maxSum))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Дата закупки:")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.dateStart))])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("Ожидаемая прибыль (%):")]), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "align-end"
    }, [_vm._v(_vm._s(project.profitExpected))])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
      attrs: {
        "pa-3": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "success"
      },
      on: {
        "click": function($event) {
          return _vm.invest(project.id)
        }
      }
    }, [_vm._v("Инвестировать")])], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', [_vm._v("Мои инвестиции")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "elevation-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.myProjects,
      "hide-actions": "",
      "item-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.clickProject(props.item)
            }
          }
        }, [_c('a', [_vm._v(_vm._s(props.item.name))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.sumMy))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.profit))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('v-layout', {
    staticClass: "overlay",
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9bd1af8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectsList.vue
// module id = 470
// module chunks = 1